import React, { useState } from 'react';

function Testimonial () {
  
  const words=[
    {id:0,value:"hardworking and smart, best working experience so far",author:"Divine ahmaradu ~CEO Hairs by Dee Dee"},
    {id:1,value:"needed just a little push and encouragement to create some of the most inspiring deigns i have seen",author:"Edward paul ~CEO Quaints Designs"},
    {id:2,value:"always willing to go the extra mile to produce incredible solutions",author:"Abigail Abimiku ~MD ASEOFO"},
    {id:3,value:"A very creative mind and an asset to the team",author:"samuel okposio ~teammate simplicity complex nigeria"},
    {id:4,value:"attentive to detail and always willing to make adjustments",author:"Rit gida ~ COO simplicity concept nigeria"},

  ];
  const [wordData,setWordData]=useState(words[0].value)
  const [authorData,setAuthorData]=useState(words[0].author)
  const handleClick=(index)=>{

    const wordSlider=words[index].value;
    setWordData(wordSlider);
   const authorSlider =words[index].author;
    setAuthorData(authorSlider);
  }
  
  return (
    <section className="text-center text-sm md:text-2xl mt-6 h-40 bg-gradient-to-r from-indigo-500 via-purple-500 to-purple-700">
      <div className='text-white py-4 italic'>" {wordData} "</div>
      <div className='text-white italic text-sm'>" {authorData} "</div>
      <div className='flex justify-center'>
        {words.map((data,i)=>
          <a key={i} onClick={()=>handleClick(i)} className="dot"></a>
        )}
      </div>
    </section>
  );
}

export default Testimonial;